module.exports = __webpack_public_path__ + "img/tensiometre.a0e61f60.png";